import React, { useState, useEffect } from 'react';
import { Container, Button, Table, Spinner } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../Styles/yellowcalfcss/ViewBill.css';
import { simplePostCall } from '../../api/ApiServices';
import ApiConfig from '../../api/ApiConfig';
import ScaleLoader from 'react-spinners/ScaleLoader';

export default function ViewBill() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [billHeader, setBillHeader] = useState({ billNo: '', supplier: '', date: '', dueDate: '' });
  const [customerInfo, setCustomerInfo] = useState({ name: '', city: '' });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (id) loadBillDetails();
  }, [id]);

  const loadBillDetails = async () => {
    setIsLoading(true);
    try {
      const response = await simplePostCall(ApiConfig.billview, JSON.stringify({
        customer_id: Number(localStorage.getItem("customer_id")),
        api_key: localStorage.getItem("api_key"),
        user_id: Number(localStorage.getItem("user_id")),
        id: Number(id),
      }));

      if (response?.result && response.data?.length > 0) {
        const firstRow = response.data[0];
        const cust = response.customer?.[0];

        setCustomerInfo({
          name: cust?.customer_name || "Demo School",
          city: cust?.customer_city || "TVM, Kerala, India",
        });

        setBillHeader({
          billNo: firstRow.bill_number || "N/A",
          supplier: firstRow.supplier_name || firstRow.bill_supplier || "N/A",
          date: firstRow.bill_date || "N/A",
          dueDate: firstRow.bill_due_date || "N/A",
        });

        setItems(response.data.map(row => ({
          name: row.bill_item_name,
          qty: row.bill_item_quantity || 0,
          price: row.bill_item_price || 0,
          total: row.total_amount || 0
        })));
      }
    } catch (error) { console.error(error); }
    finally { setIsLoading(false); }
  };

  const totalAmount = items.reduce((sum, item) => sum + (Number(item.total) || 0), 0);

  if (isLoading) return <div className="text-center mt-5"> <ScaleLoader color="#F4BB44" /></div>;

  return (
    <div className="view-bill-page">
      {/* 1. TOP ACTION BAR (Hidden on Print) */}
      <div className="no-print d-flex justify-content-between p-3 bg-light border-bottom mb-4">
        <Button variant="secondary" onClick={() => navigate(-1)}>← Back</Button>
        <Button variant="warning" onClick={() => window.print()}>Print Bill</Button>
      </div>

      <Container fluid className="invoice-paper" style={{margin: '0 10px'}}>
        {/* 2. SCHOOL HEADER */}
        <div className="invoice-header text-center mb-4">
          <h2 className="school-name">{customerInfo.name}</h2>
          <p className="school-address">{customerInfo.city}</p>
          <hr className="header-line" />
          <h4 className="invoice-title">PURCHASE BILL</h4>
        </div>

        {/* 3. BILL INFO (CLEAN TWO-COLUMN LAYOUT) */}
        <div className="bill-meta mb-4">
          <div className="row">
            <div className="col-6">
              <p><strong>Bill No:</strong> {billHeader.billNo}</p>
              <p><strong>Supplier:</strong> {billHeader.supplier}</p>
            </div>
            <div className="col-6 text-end">
              <p><strong>Date:</strong> {billHeader.date}</p>
              <p><strong>Due Date:</strong> {billHeader.dueDate}</p>
            </div>
          </div>
        </div>

        {/* 4. ITEMS TABLE (Solid Border for Print) */}
        <Table bordered className="invoice-table">
          <thead>
            <tr>
              <th width="80px">Sr No</th>
              <th>Items</th>
              <th className="text-center">Quantity</th>
              <th className="text-end">Unit Price</th>
              <th className="text-end">Item Total</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={index}>
                <td className="text-center">{index + 1}</td>
                <td>{item.name}</td>
                <td className="text-center">{item.qty}</td>
                <td className="text-end">{item.price}</td>
                <td className="text-end">{item.total}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan="4" className="text-end">Total Bill Amount</th>
              <th className="text-end total-cell">{totalAmount}</th>
            </tr>
          </tfoot>
        </Table>

        <div className="invoice-footer mt-5 text-center">
          <p className="text-muted small">Generated on {new Date().toLocaleDateString()}</p>
        </div>
      </Container>

      {/* 5. CSS FOR PRINT FIXES */}
      <style>{`
        /* Regular Screen View */
        .invoice-paper {
          background: white;
          padding: 40px;
          min-height: 800px;
          box-shadow: 0 0 10px rgba(0,0,0,0.1);
          border-radius: 8px;
          margin-bottom: 50px;
        }
        .invoice-title { color: #555; font-weight: bold; border-bottom: 2px solid #eee; display: inline-block; padding-bottom: 5px; }
        .total-cell { background-color: #f8f9fa !important; font-size: 1.1rem; }

        /* Print Specific View */
        @media print {
          /* Hide EVERYTHING except the invoice paper */
          body * { visibility: hidden; }
          .no-print { display: none !important; }
          .view-bill-page, .view-bill-page * { visibility: visible; }
          .view-bill-page { position: absolute; left: 0; top: 0; width: 100%; }

          .invoice-paper {
            box-shadow: none !important;
            border: none !important;
            padding: 0 !important;
            margin: 0 !important;
            width: 100% !important;
          }

          .invoice-table thead { background-color: #eee !important; -webkit-print-color-adjust: exact; }
          .header-line { border-top: 2px solid #000 !important; }
          
          @page { margin: 1.5cm; }
        }
      `}</style>
    </div>
  );
}